import { DsToastRegion } from '@frontends/ds';
import { SpriteProvider } from '@frontends/ds-icons';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Suspense } from 'react';
import { I18nextProvider } from 'react-i18next';
import { BrowserRouter } from 'react-router';
import { preSaveEmbedEntryQuery } from '@/utils/embedAuth';
import B2CoreEmbedBridge from './components/B2CoreEmbedBridge';
import B2CoreEmbedPalette from './components/B2CoreEmbedPalette';
import Spinner from './components/Spinner';
import { useEntityConfig } from './hooks/useEntityConfig';
import i18n from './lib/i18n';
import { AuthProvider } from './providers/AuthProvider';
import { PreferencesGateway } from './providers/PreferencesGateway';
import { RacRouterProvider } from './providers/RacRouterProvider';
import AppRoutes from './routes';

const queryClient = new QueryClient();

preSaveEmbedEntryQuery();

function App() {
  const config = useEntityConfig();
  document.title = config.VITE_APPLICATION_TITLE;

  // Auth sits above preferences so the client id reaches them; the theme and locale
  // providers live inside PreferencesGateway, which is their single writer.
  return (
    <I18nextProvider i18n={i18n}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <RacRouterProvider>
            <AuthProvider>
              <PreferencesGateway>
                <SpriteProvider>
                  <B2CoreEmbedPalette />
                  <Suspense fallback={<Spinner />}>
                    <B2CoreEmbedBridge />
                    <AppRoutes />
                  </Suspense>

                  <DsToastRegion placement="top end" className="md:end-6 md:top-16" />
                </SpriteProvider>
              </PreferencesGateway>
            </AuthProvider>
          </RacRouterProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </I18nextProvider>
  );
}

export default App;
